{
  "linkTo": "Set Path",
  "parkingSpotWithNumber": "Spot {{number}}",
  "pathNotSetWarning": "Linear path not configured. Set a path to enable linear move tracking features.",
  "setLinearPath": "Set Linear Path",
  "stageParkingSpots": {
    "cancelText": "Back",
    "instructions": "Set the parking spots on the base station path.",
    "title": "Parking Spots"
  },
  "stagePathEnd": {
    "cancelText": "Back",
    "instructions": "Set the end point of the base station path by tapping the map.",
    "title": "End Point"
  },
  "stagePathStart": {
    "cancelText": "Cancel",
    "instructions": "Set the start point of the base station path by tapping the map.",
    "title": "Start Point"
  },
  "stageSwath": {
    "cancelText": "Back",
    "instructions": "Set the width of the swath. Press 'Flip' to reverse the swath direction.",
    "title": "Swath"
  },
  "title": "Set Linear-Move Path"
}
